import React from 'react';
import { Modal, Row, Col, Tag, Image } from 'antd';
import '../styles.less';

const PreviewTemplateModal = ({ visible, onCancel, template }) => {
  const renderPreviewContent = (content) => {
    if (!content) return '';

    const placeholders = {
      '{customer_name}': 'Nguyễn Văn A',
      '{product_name}': 'iPhone 15 Pro',
      '{order_id}': 'DH123456',
      '{price}': '25.000.000 VNĐ',
      '{date}': new Date().toLocaleDateString('vi-VN'),
    };

    let previewContent = content;
    Object.entries(placeholders).forEach(([placeholder, value]) => {
      previewContent = previewContent.replace(new RegExp(placeholder, 'g'), value);
    });

    return previewContent;
  };

  const getImageUrl = (image) => {
    if (!image) return null;
    return typeof image === 'string' ? image : image.url;
  };

  if (!template) return null;

  return (
    <Modal
      title="Xem trước Template"
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width={900}
      className="preview-template-modal"
    >
      <Row gutter={24}>
        <Col span={10}>
          <div className="preview-field">
            <span className="preview-label">Tiêu đề template</span>
            <span className="preview-required">*</span>
            <span className="preview-value">{template.title}</span>
          </div>

          <div className="preview-field">
            <span className="preview-label">Danh mục</span>
            <span className="preview-required">*</span>
            <Tag color="blue">{template.category || 'Chưa phân loại'}</Tag>
          </div>

          {template.tags && template.tags.length > 0 && (
            <div className="preview-field">
              <span className="preview-label">Tags</span>
              <span className="preview-tags">
                {template.tags.map((tag, index) => (
                  <span key={index} className="preview-tag-item">{tag}</span>
                ))}
              </span>
            </div>
          )}

          <div className="preview-field">
            <span className="preview-label">Trạng thái</span>
            <span
              className="preview-status"
              style={{ color: template.isActive ? '#4F7CFE' : '#C9557E' }}
            >
              {template.isActive ? 'Đang hoạt động' : 'Không hoạt động'}
            </span>
          </div>

          <div className="preview-field preview-content-field">
            <span className="preview-label">Nội dung template</span>
            <span className="preview-required">*</span>
            <div className="preview-content-text">{template.content}</div>
          </div>
        </Col>

        <Col span={14}>
          <div className="preview-section">
            <div className="preview-header">Preview</div>
            <div className="preview-content-wrapper">
              <div className="preview-bubble-container">
                <div className="preview-bubble">
                  {renderPreviewContent(template.content)}
                </div>
              </div>
              {template.image && (
                <div className="preview-image-container">
                  <Image
                    src={getImageUrl(template.image)}
                    alt="Template"
                    className="preview-image"
                  />
                </div>
              )}
            </div>
          </div>
        </Col>
      </Row>
    </Modal>
  );
};

export default PreviewTemplateModal;
